export default __webpack_public_path__ + "static/media/My Pizza.d433c844.jpg";